import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const HomeIcon = (props) => (
  <SvgIcon {...props}>
    <path d="M10.118 20v-5.647h3.764V20h4.706v-7.53h2.824L12 4l-9.412 8.47h2.824V20z" />
  </SvgIcon>
);
HomeIcon.displayName = 'HomeIcon';
HomeIcon.muiName = 'SvgIcon';

export default HomeIcon;
